import { type NewContainer } from '@sr/types';

/**
 * D365FO container type ids (shared by SE and DK) where pallet collars can be added:
 * Pallets EUR/SJ, Pallet, Disposable pallet and Pallet & Collar.
 * Chemical cartons on pallets (210/211) and the collar itself (319) are not included.
 */
export const PALLET_CONTAINER_TYPE_IDS = ['122', '090', '076', '005'] as const;

export const isPalletContainerType = (containerType?: string) =>
  !!containerType && PALLET_CONTAINER_TYPE_IDS.some((id) => id === containerType);

/**
 * Number of pallet collars ordered together with a pallet container.
 * Collars are only meaningful on pallet containers; any other container reports 0.
 */
export const getPalletCollarAmount = (
  container: Pick<NewContainer, 'containerType' | 'palletCollarAmount'>,
) => {
  if (!isPalletContainerType(container.containerType)) {
    return 0;
  }

  return container.palletCollarAmount ?? 0;
};
